import EmpleadoTable from "./EmpleadoTable";
import CardLayout from "../Layout/CardLayout";
import React from "react";
import CostoFijosTable from "./CostoFijosTable";

const CostoTotal = (ciemId) => {

    const contributionForm =
        <CostoFijosTable optionName={"costoTotalTable"}
                         ciemId={ciemId}
                        />
    ;

    return (
        <div className="container-fluid">
            <CardLayout value={"costoTotalTitulo"} tablaComponent={contributionForm} />
        </div>
    );
};

export default CostoTotal;